import { HOC_MDXWrapper } from 'nextra/setup-page'
import { pageMap } from '/ui/docs-site/.next/static/chunks/nextra-page-map-.mjs'
/*@jsxRuntime automatic*/
/*@jsxImportSource react*/
/*-- dri: Adam Locke --*/
import {useMDXComponents as _provideComponents} from "nextra/mdx";
const title = "Trace Explorer";
const frontMatter = {
  "title": "Trace Explorer",
  "description": "Use Trace Explorer in Chronosphere Observability Platform to search for traces and spans to understand the root cause of issues."
};
import {Alert, Icon} from '@/components';
import {mdiCompass} from '@mdi/js';
export function useTOC(props) {
  return [{
    value: "Prerequisites",
    id: "prerequisites",
    depth: 2
  }];
}
function MDXLayout(props) {
  const {toc = useTOC(props)} = props;
  const _components = {
    a: "a",
    h1: "h1",
    h2: "h2",
    p: "p",
    strong: "strong",
    ..._provideComponents(),
    ...props.components
  };
  return <>{}{"\n"}<_components.h1>{"Trace Explorer"}</_components.h1>{"\n"}<_components.p>{"Use the Trace Explorer to search for traces and spans so that you can identify,\ntriage, and understand the root cause of problems. You can view all trace data that’s\nrelevant to a particular issue, and compare that trace against a previous time period\nto better understand where errors are occurring."}</_components.p>{"\n"}<_components.p>{"To explore traces, in the navigation menu select\n"}<_components.strong><Icon path={mdiCompass} />{" Explorers "}<span aria-label="and then">{">"}</span>{" Trace\nExplorer"}</_components.strong>{". From there, you can "}<_components.a href="/investigate/querying/traces">{"search and filter"}</_components.a>{"\ntrace data, and use "}<_components.a href="/investigate/differential-diagnosis/traces">{"differential diagnosis"}</_components.a>{"\nto identify issues behind suspicious trends."}</_components.p>{"\n"}<_components.p>{"See the "}<_components.a href="/investigate/traces/explorer/features">{"features overview"}</_components.a>{" to learn more about\nthe capabilities that Trace Explorer provides."}</_components.p>{"\n"}<_components.h2 id={toc[0].id}>{toc[0].value}</_components.h2>{"\n"}<_components.p>{"To explore tracing data in Chronosphere Observability Platform, you must either\ninstall and configure the Chronosphere-provided\n"}<_components.a href="/ingest/metrics-traces/collector/install/tracing">{"Collector"}</_components.a>{" or the\n"}<_components.a href="/ingest/metrics-traces/otel/otel-ingest">{"OpenTelemetry Collector"}</_components.a>{" to receive trace\ndata from your services."}</_components.p></>;
}


export default HOC_MDXWrapper(
  MDXLayout,
  '/investigate/traces/explorer',
  {"filePath":"pages/investigate/traces/explorer.mdx",pageMap,frontMatter,title},
  typeof RemoteContent === 'undefined' ? useTOC : RemoteContent.useTOC
)